import axios from 'axios';
import getUrl from 'utils/getUrl';

import { generateApiError } from './utils/apiErrorMessages';

const updateSectionBlockOrder = (
  collectionPath,
  entityId,
  { section, orderMap },
) =>
  axios
    .patch(getUrl.apiV2(`${collectionPath}/${entityId}/section/order`), {
      section,
      order_map: orderMap,
    })
    .catch(generateApiError());

export default updateSectionBlockOrder;
